import React, { useState } from "react";
import { 
  Spinner, 
  SpinnerSize, 
  Stack } from "@fluentui/react";
import styles from "./AssistantTypeSection.module.css";
import { SearchIndex } from "../../api/models";

type AssistantTypeSectionProps = { 
  isAssistantAPILoading: boolean;
  onExampleClicked: (content: string) => void;
  availableIndexes?: SearchIndex[];
};

export const AssistantTypeSection: React.FC<AssistantTypeSectionProps> = ({  
  isAssistantAPILoading,
  onExampleClicked,
  availableIndexes = []
}) => {
  const [drawerOpen, setDrawerOpen] = useState(true);

  return (
    <Stack className={styles.chatEmptyState}>                  
      {isAssistantAPILoading ? (        
        <div className={styles.loadingContainer}>
          <Spinner size={SpinnerSize.large} label="Establishing connection..." />
        </div>
      ) : (
        <>
          <h1 className={styles.chatEmptyStateTitle}>
            Welcome to
            <span className={styles.dataText}>&nbsp;AURA</span>
          </h1>
          <p className={styles.auraTagline}>Adaptive User Retail Assistant</p>

          {availableIndexes.length > 0 && (
            <>
              <button
                className={styles.drawerToggle}
                onClick={() => setDrawerOpen(!drawerOpen)}
                aria-expanded={drawerOpen}
              >
                <span>What can I search?</span>
                <span className={`${styles.drawerChevron} ${drawerOpen ? styles.drawerChevronOpen : ''}`}>▾</span>
              </button>

              {drawerOpen && (
                <div className={styles.drawerContent}>
                  {availableIndexes.map((index) => (
                    <span key={index.id} className={styles.capabilityChip}>{index.displayName}</span>
                  ))}
                </div>
              )}
            </>
          )}
        </>      
      )}
    </Stack>
  );
};
